// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"71":"f457c1cc","413":"8ff62587","597":"091418f1"}[chunkId] + ".js";
};